import { Component, OnInit } from '@angular/core';

import { ReportsService } from '../../services/reports.service';

import { ReportsConstants } from '../../reports.const';

@Component({
  selector: 'app-income',
  templateUrl: './income.component.html'
})
export class IncomeComponent implements OnInit {

  incomeData : Array<any> = [];
  year: number;
  years: Array<number> = [];
  month: number;

  reportsConstants:any = ReportsConstants;

  constructor(
    private reportsService : ReportsService
  ) { }

  ngOnInit() {
    let date = new Date();
    this.years = this.getYears(date);
    this.year = date.getFullYear();
    this.month = date.getMonth()+1;
    this.getIncome();
  }

  getYears(date: Date){
    let currentYear = date.getFullYear();
    return [currentYear-3, currentYear-2, currentYear-1, currentYear];
  }

  getIncome(){
    this.reportsService.getIncome({year: this.year, month: this.month}).subscribe(
      res => {
        this.incomeData = res.data;
        console.log(res.data);
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/reports/components/income/income.component.ts